import { useAuthenticationContext } from '@psyomics/ui-common';
import { LoadingSpinner, PageLayout } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { UploadCsvForm } from './components/upload-csv-form/upload-csv-form';
import { useServiceForUpload } from './use-service-for-upload';

type UploadReferralsProps = {
  readonly serviceCode: string;
};

const UploadReferrals = ({ serviceCode }: UploadReferralsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { organisation } = useAuthenticationContext();
  const { service, pending } = useServiceForUpload(serviceCode);

  if (pending) return <LoadingSpinner />;
  if (!service) return null;

  return (
    <PageLayout
      background="muted"
      title={t('page.referralUploadJobs.uploadTitle', { serviceDescription: service.description })}
      width="wide"
    >
      <UploadCsvForm
        onUploadAcknowledged={() => navigate(`/account/${organisation}/home/bulk-referral-uploads`)}
        service={service}
      />
    </PageLayout>
  );
};

export { UploadReferrals };
